import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const FullscreenFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function FullscreenFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M19 2.5H5c-2.21 0-4 1.79-4 4v11c0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4v-11c0-2.21-1.79-4-4-4ZM9.5 8h-3v3h-2V6h5v2Zm10 10h-5v-2h3v-3h2v5Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default FullscreenFilled;